import { Button, Col, Form, Row } from "react-bootstrap";
import CabinCard from "./CabinCard";
import React from "react";

const AssignCabin = (props: any) => {
  const { payloadObj, setPayloadObj, cabinsData, loader, commonOption, cabinCategoryData, setCabinCategoryData, setSpecialPricingUpgradeOffer, specialPricingUpgradeOffer } = props;

  // Temporarily Commented
  // const handleAssignmentClick = (assignmentType: string) => {
  //   switch (assignmentType) {
  //     case "AUTO":
  //       const tempObj = { ...payloadObj };
  //       if (tempObj?.roomSelectionType) delete tempObj.roomSelectionType;
  //       setPayloadObj({ ...tempObj, assignmentType: commonOption?.assignment[assignmentType] });
  //       break;
  //     case "MANUAL":
  //       setPayloadObj({ ...payloadObj, assignmentType: commonOption?.assignment[assignmentType], 
  //         roomSelectionType: commonOption?.room_selection?.AGENT, });
  //       break;
  //     default:
  //       break;
  //   }
  // }
  
  return (
    <>
      <Row className="mt-1">
        <Col xs={12} sm={4}>
          <Form.Text className="main-heading">ASSIGN CABIN</Form.Text>
        </Col>
        {/* Temporarily Commented */}
        {/* <Col xs={12} sm={8}>
          <div className="d-flex  justify-content-evenly ">
            <Button
              type="submit"
              className={` mx-1  ${
                payloadObj?.assignmentType === commonOption?.assignment?.AUTO ? "mainBtn createBtn" : "mainBtn Grey-Btn"
              }`}
              //   style={{ maxLines: '150px' }}
              onClick={() => handleAssignmentClick('AUTO')}>
              Auto Assign
            </Button>
            <Button
              type="submit"
              className={` mx-1   ${
                payloadObj?.assignmentType === commonOption?.assignment?.MANUAL
                  ? "mainBtn createBtn"
                  : "mainBtn Grey-Btn"
              }`}
              //   style={{ maxLines: '150px' }}
              onClick={() => handleAssignmentClick('MANUAL')}>
              Manual Assign
            </Button>
          </div>
        </Col> */}
      </Row>
      {/* Temporarily commented */}
      {/* {payloadObj?.assignmentType?.includes('manual') && <Row className="mt-4">
        <Col xs={12} sm={4}>
          <Form.Text className="main-heading">ASSIGN ROOM</Form.Text>
        </Col>
        <Col xs={12} sm={8}>
          <div className="d-flex  justify-content-evenly ">
            <Button
              type="submit"
              className={` mx-1  ${
                payloadObj?.roomSelectionType === commonOption?.room_selection?.AGENT
                  ? "mainBtn createBtn"
                  : "mainBtn Grey-Btn"
              }`}
              //   style={{ maxLines: '150px' }}
              onClick={() => setPayloadObj({ ...payloadObj, roomSelectionType: commonOption?.room_selection?.AGENT })}>
              Agent Selection
            </Button>
            <Button
              type="submit"
              className={` mx-1 ${
                payloadObj?.roomSelectionType === commonOption?.room_selection?.GUEST
                  ? "mainBtn createBtn"
                  : "mainBtn Grey-Btn"
              }`}
              //   style={{ maxLines: '150px' }}
              onClick={() => setPayloadObj({ ...payloadObj, roomSelectionType: commonOption?.room_selection?.GUEST })}>
              Guest Selection
            </Button>
          </div>
        </Col>
      </Row>} */}
      <>
        <Row className="mt-4 flex-wrap">
          <Col xs={12} sm={4}>
            <Form.Check
              label="Connecting Rooms"
              type={"checkbox"}
              className="quotation-checkbox"
              value={commonOption?.preference?.CONNECTING_ROOMS}
              onChange={(e) => {
                if (e.target.checked) {
                  setPayloadObj({ ...payloadObj, preference: [...payloadObj?.preference, e.target.value] });
                } else {
                  setPayloadObj({
                    ...payloadObj,
                    preference: [
                      ...payloadObj?.preference?.filter((item: any) => {
                        if (item !== e.target.value) {
                          return item;
                        }
                      }),
                    ],
                  });
                }
              }}
            />
          </Col>
          <Col xs={12} sm={4}>
            <Form.Check
              label="Wheel Chair Access"
              type={"checkbox"}
              className="quotation-checkbox"
              value={commonOption?.preference?.WHEEL_CHAIR_ACCESS}
              onChange={(e) => {
                if (e.target.checked) {
                  setPayloadObj({ ...payloadObj, preference: [...payloadObj?.preference, e.target.value] });
                } else {
                  setPayloadObj({
                    ...payloadObj,
                    preference: [
                      ...payloadObj?.preference?.filter((item: any) => {
                        if (item !== e.target.value) {
                          return item;
                        }
                      }),
                    ],
                  });
                }
              }}
            />
          </Col>
          <Col xs={12} sm={4}>
            <Form.Check
              label="Balcony View"
              type={"checkbox"}
              className="quotation-checkbox"
              value={commonOption?.preference?.BALCONY_VIEW}
              onChange={(e) => {
                if (e.target.checked) {
                  setPayloadObj({ ...payloadObj, preference: [...payloadObj?.preference, e.target.value] });
                } else {
                  setPayloadObj({
                    ...payloadObj,
                    preference: [
                      ...payloadObj?.preference?.filter((item: any) => {
                        if (item !== e.target.value) {
                          return item;
                        }
                      }),
                    ],
                  });
                }
              }}
            />
          </Col>
          <Col xs={12} sm={4}>
            <Form.Check
              label="Square Window"
              type={"checkbox"}
              className="quotation-checkbox"
              value={commonOption?.preference?.SQUARE_WINDOW}
              onChange={(e) => {
                if (e.target.checked) {
                  setPayloadObj({ ...payloadObj, preference: [...payloadObj?.preference, e.target.value] });
                } else {
                  setPayloadObj({
                    ...payloadObj,
                    preference: [
                      ...payloadObj?.preference?.filter((item: any) => {
                        if (item !== e.target.value) {
                          return item;
                        }
                      }),
                    ],
                  });
                }
              }}
            />
          </Col>
        </Row>
        <Row className="my-2">
          <Col xs={12} sm={4}>
          <Form.Check
              label="Special Pricing"
              type={"checkbox"}
              className="quotation-checkbox"
              value={specialPricingUpgradeOffer.specialPricing}
              onChange={(e) => { setSpecialPricingUpgradeOffer((prev: any) => ({ ...prev, specialPricing: e.target.checked })); }}
            />
          </Col>
          <Col xs={12} sm={4}>
          <Form.Check
              label="Upgrade Offer"
              type={"checkbox"}
              className="quotation-checkbox"
              value={specialPricingUpgradeOffer.upgradeOffer}
              onChange={(e) => { setSpecialPricingUpgradeOffer((prev: any) => ({ ...prev, upgradeOffer: e.target.checked })); }}
            />
          </Col>
        </Row>
        <Row className="mt-3 flex-wrap px-1">
          <Form.Text className="quotation-heading mb-3">Select Available Cabins</Form.Text>
          {/* <Col xs={12} sm={6}>
            <Form.Check label="Show Discount Price" type={"checkbox"} className="quotation-checkbox" />
          </Col> */}
          {/* <Col xs={12} sm={3}>
            <Form.Text className="input-label quotation">Available Rooms</Form.Text>
          </Col> */}
          {/* <Col xs={12} sm={3} className="d-flex justify-content-end">
            <Form.Text className="input-label quotation">Price/Person</Form.Text>
          </Col> */}
        </Row>
        <>
          {(!!cabinsData?.length && !loader) ?
            <div className="selling-box">
              <div className="flex justify-between w-100">
                <Form.Text className="input-label success text w-100">ROOMS AVAILABLE</Form.Text>
                <div className="flex justify-between w-100">
                  <Form.Text className="input-label quotation -ml-1.5">Available Rooms</Form.Text>
                  <Form.Text className="input-label quotation">Price/Person</Form.Text>
                </div>
              </div>
              <Row className="cabin-pricing mt-2">
                {cabinsData?.map((data: any) => (
                  <React.Fragment key={data?.room_category_id}>
                    <CabinCard cabinInfo={data} cabinCategoryData={cabinCategoryData} setCabinCategoryData={setCabinCategoryData} payloadObj={payloadObj} specialPricingUpgradeOffer={specialPricingUpgradeOffer} />
                  </React.Fragment>
                ))}
              </Row>
            </div> : loader ? <p className="w-full text-xl text-center">Fetching Available Rooms...</p> : 
            <p className="w-full text-xl text-center">No Rooms Available</p>}
        </>
      </>
    </>
  );
};
export default AssignCabin;
